// extracted by mini-css-extract-plugin
export default {"todayLabelContainer":"MultiDateSelector_todayLabelContainer__dnw2T"};